export const NavigationButton = [
    {
        label: 'Ground Files',
        name: 'files-ground-files',
        used_by: ['operate', 'simulation', 'summary']
    },
    {
        label: 'On-Board Files',
        name: 'files-onboard-files',
        used_by: ['operate', 'simulation', 'summary']
    }
]

export const get_navigator_button_by_dashboard = (dashboard: string) => {
    return NavigationButton.filter(item => item.used_by.includes(dashboard))
}